import { ShoppingListService } from "@/clients/services/ShoppingListService";
import { QueryKeys } from "@/constants/query-keys";
import { QueryStaleTime } from "@/constants/query-stale-time";
import { guardGetUserFromLocalStorage } from "@/utils/request";
import { useQuery } from "@tanstack/react-query";

/**
 * Hook to fetch the shopping list for the current user
 * Automatically refetches on mount and window focus to ensure fresh data
 * @returns Shopping list data with ingredients grouped by category
 */
export const useGetShoppingList = () => {
  const { data, isLoading, isRefetching, isError, error, refetch } = useQuery({
    queryKey: [QueryKeys.SHOPPING_LIST],
    queryFn: async () => {
      const user = guardGetUserFromLocalStorage();
      const response =
        await ShoppingListService.getShoppingListApiV1ShoppingListGet(user.id);
      return response?.ingredients ?? [];
    },
    // Ensure fresh data on mount and window focus
    staleTime: QueryStaleTime.ZERO,
    refetchOnMount: true,
    refetchOnWindowFocus: true,
  });

  return {
    ingredients: data,
    isLoading,
    isRefetching,
    isError,
    error,
    refetchShoppingList: refetch,
  };
};
